import { Redirect } from './Redirect';

export default Redirect;
